export const COOKIE_NAME_USER_VISIT =
  process.env.COOKIE_NAME_USER_VISIT ?? 'userVisit'
